import styled from 'styled-components'

export default styled.time`
  font-variant-numeric: tabular-nums;
  font-size: 75%;
`
